module.exports = function(aiModule) {
	'use strict'
    aiModule
    .controller('aiAllConfigurationsController', aiAllConfigurationsController)
	aiAllConfigurationsController.$inject = ["$filter","aiModalService","$attrs","watchAllCheckboxesNgTable","removeFromOther","addToOther","warningAlertService","$timeout","config","$stateParams","$state","API_URL","deleteDataService","$http","cleanObj","$scope","$rootScope","NgTableParams", "getDataService", "jQuery","refreshtokenService","reqursiveService","postDataService","alertService","putDataService","$interval","authtokenService","serverError","comunicateBetweenViews","checkArray","$window","offlineError"];
	
    function aiAllConfigurationsController($filter,aiModalService,$attrs,watchAllCheckboxesNgTable,removeFromOther,addToOther,warningAlertService,$timeout,config,$stateParams,$state,API_URL,deleteDataService,$http, cleanObj,$scope,$rootScope,NgTableParams,getDataService,jQuery,refreshtokenService,reqursiveService,postDataService,alertService, putDataService,$interval, authtokenService,serverError,comunicateBetweenViews,checkArray,$window, offlineError) {
        var vmaac = this;
        if($stateParams.id) {
            vmaac.configurationEdit = true;
        } else {
            vmaac.configurationEdit = false;
        }
        var $data;
        vmaac.selectedFunctionality = {value: 'all'};
        vmaac.status = 'all';
        vmaac.searchData = {name: ''};

        function applyAllFilters() {
            var filteredData = vmaac.copydataConfigurations;

            // Apply status filter
            if (vmaac.status !== 'all') {
                filteredData = $filter('filter')(filteredData, { active: vmaac.status === 'active' });
            }

            // Apply functionality filter
            if (vmaac.selectedFunctionality.value !== 'all') {
                filteredData = $filter('filter')(filteredData, function(item) {
                    return item.functionality === vmaac.selectedFunctionality.value;
                });
            }

            // Apply search filter
            if (vmaac.searchData.name) {
                filteredData = $filter('filter')(filteredData, vmaac.searchData);
            }

            vmaac.dataConfigurations = filteredData;
            tablePopulateFunction();
        }

        vmaac.changeStatus = function(event, activeStatus) {
            vmaac.status = activeStatus;
            applyAllFilters();
        }

        vmaac.switchFunctionality = function(functionalityId) {
            vmaac.selectedFunctionality.value = functionalityId;
            applyAllFilters();
        }

        vmaac.changeSearch = function(searchData) {
            vmaac.searchData = searchData;
            applyAllFilters();
        }

        vmaac.clearAllFilters = function() {
            vmaac.selectedFunctionality = {value: 'all'};
            vmaac.status = 'all';
            vmaac.searchData = {name: ''};
            vmaac.dataConfigurations = vmaac.copydataConfigurations;
            tablePopulateFunction();
        }
        vmaac.deleteConfiguration = function(configuration) {
            if(configuration.active) {
                alertService('danger','Opps! ', 'This configuration is active and cannot be deleted.');
                return;
            }
            aiModalService.delete('configurations/'+ configuration._id, function(data) {
                if(data.message) {
                    alertService('success','Success ', data.message, 3000);
                }
                getConfigurations();
            }, function(message) {
                alertService('danger','Opps! ', message);
            })
        }
        vmaac.editConfiguration = function(configurationId) {
            vmaac.configurationEdit= true;
            jQuery("html, body").animate({
                scrollTop: 0
            }, 10);
            vmaac.configurationId = configurationId;
            $state.transitionTo('app.ai_all_configurations', {id: vmaac.configurationId}, {
                location: true,
                inherit: true,
                relative: $state.$current,
                notify: false
            });
        }
        aiModalService.get('functionality-list', function(data) {
            if(data.results && data.results.length > 0) {
                vmaac.functionalityList = data.results.map(function(item) {
                    var name = item.split('-').join(' ');
                    name = name.charAt(0).toUpperCase() + name.slice(1);
                    return {
                        _id: item,
                        name: name
                    }
                });
            }
        });

        var tablePopulateFunction = function() {
            vmaac.tableParams = new NgTableParams({
              page: 1,
              count: 20,
             
            }, {
                total:vmaac.dataConfigurations.length,
                counts: false,
                getData: function(params) {
                    $data = vmaac.dataConfigurations; 
                    $data = params.sorting() ?
                    $filter('orderBy')($data, params.orderBy()) : $data;
                    $data = $data.slice((params.page() - 1) * params.count(), params.page() * params.count());
                    vmaac.dataGet = $data;
                    jQuery('.goTo input').val("");  
                    if(vmaac.dataConfigurations.length == 0) {
                        $rootScope.emptyTable = true;
                    } else {
                        $rootScope.emptyTable = false;
                    } 
                    return $data; 
                }    
            });  
        }
        vmaac.getConfigurations = function(update) {
            $rootScope.hasLoaded = false;
            aiModalService.get('configurations',function(data){
                vmaac.dataConfigurations = data;
                vmaac.copydataConfigurations = angular.copy(vmaac.dataConfigurations);
                $rootScope.hasLoaded = true;
                if(update) {
                    vmaac.tableParams.reload(vmaac.tableParams.page());
                } else {
                    tablePopulateFunction();
                }
            }, function(message){ 
                alertService('danger','Opps! ', message);
            })
        }
        vmaac.getConfigurations();
        if(!window.navigator.onLine) {
            offlineError('refresh')
            return
        }
        
    }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/aiModule/all-configurations/js/aiAllConfigurationsController.js
// module id = 486
// module chunks = 0